import styled from '@emotion/styled'
export default styled('div')`
  font-weight: 600;
  font-size: 14px;
`
